export enum EBloomAlgal {
    Oui = 1,
    Non = 2,
}